// src/arrays-contain-same-elements/index.ts
var arraysContainSameElements = (arr1, arr2) => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  return arr1.every((item) => set2.has(item)) && arr2.every((item) => set1.has(item));
};
var arrays_contain_same_elements_default = arraysContainSameElements;

// src/dig/index.ts
var dig = (obj, path, defaultValue = void 0) => {
  const travel = (regexp) => String.prototype.split.call(path, regexp).filter(Boolean).reduce(
    (res, key) => res !== null && res !== void 0 ? res[key] : res,
    obj
  );
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === void 0 || result === obj ? defaultValue : result;
};
var dig_default = dig;

// src/format-camel-case/index.ts
var wordSeparatorsRegEx = /[\s\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]+/;
var basicCamelRegEx = /^[a-z\u00E0-\u00FCA-Z\u00C0-\u00DC][\d|a-z\u00E0-\u00FCA-Z\u00C0-\u00DC]*$/;
var fourOrMoreConsecutiveCapsRegEx = /([A-Z\u00C0-\u00DC]{4,})/g;
var allCapsRegEx = /^[A-Z\u00C0-\u00DC]+$/;
var formatCamelCase = ({ value }) => {
  const words = value.split(wordSeparatorsRegEx);
  const len = words.length;
  const mappedWords = new Array(len);
  for (let i = 0; i < len; i++) {
    let word = words[i];
    if (word === "") {
      continue;
    }
    const isCamelCase = basicCamelRegEx.test(word) && !allCapsRegEx.test(word);
    if (isCamelCase) {
      word = word.replace(
        fourOrMoreConsecutiveCapsRegEx,
        function(match, p1, offset) {
          return deCap(match, word.length - offset - match.length == 0);
        }
      );
    }
    let firstLetter = word[0];
    firstLetter = i > 0 ? firstLetter.toUpperCase() : firstLetter.toLowerCase();
    mappedWords[i] = firstLetter + (!isCamelCase ? word.slice(1).toLowerCase() : word.slice(1));
  }
  return mappedWords.join("");
};
function deCap(match, endOfWord) {
  const arr = match.split("");
  const first = arr.shift().toUpperCase();
  const last = endOfWord ? arr.pop().toLowerCase() : arr.pop();
  return first + arr.join("").toLowerCase() + last;
}
var format_camel_case_default = formatCamelCase;

// src/format-bytes/index.ts
var formatBytes = (bytes) => {
  const units = ["bytes", "KB", "MB", "GB"];
  let unitIndex = 0;
  while (bytes >= 1024 && unitIndex < units.length - 1) {
    bytes /= 1024;
    unitIndex++;
  }
  return `${Math.round(bytes)} ${units[unitIndex]}`;
};
var format_bytes_default = formatBytes;

// src/format-phone/index.ts
import Imask from "imask";
var DEFAULT_MASK = {
  all: {
    mask: "000-000-0000"
  },
  countryCode: {
    mask: "000-000-0000"
  }
};
var locales = { US: DEFAULT_MASK, CA: DEFAULT_MASK };
var phoneMasksForLocale = (locale) => Object.values(locales[locale] || {});
var formatPhone = ({ value, locale }) => {
  if (!value)
    return "";
  const sanitizedValue = String(value).replace(/^\+1|\D+/g, "");
  const mask = phoneMasksForLocale(locale || "US");
  return mask.length > 0 ? Imask.pipe(sanitizedValue, { mask }) : value;
};
var format_phone_default = formatPhone;

// src/formatText/index.ts
var formatText = ({ value }) => {
  let result = `<p>${value || ""}</p>`;
  result = result.replace(/\r\n\r\n/g, "</p><p>").replace(/\n\n/g, "</p><p>");
  result = result.replace(/\r\n/g, "<br />").replace(/\n/g, "<br />");
  return result;
};
var formatText_default = formatText;

// src/generate-uuid/index.ts
import { v4 as uuid } from "uuid";
function generateUUid(options = {}) {
  return uuid(options);
}

// src/inputMask/index.ts
var DEFAULT_LOCALIZED_MASKS = {
  phone: "+1 ###-###-####",
  zip: "#####"
};
var PHONE_LOCALIZED_MASKS = {
  US: DEFAULT_LOCALIZED_MASKS.phone,
  CA: DEFAULT_LOCALIZED_MASKS.phone
};
var ZIP_LOCALIZED_MASKS = {
  US: DEFAULT_LOCALIZED_MASKS.zip,
  CA: "a#a #a#"
};
var inputMaskStrategy = {
  phone: PHONE_LOCALIZED_MASKS,
  zip: ZIP_LOCALIZED_MASKS
};
var inputMask = ({ mask, locale = "US" }) => inputMaskStrategy[mask][locale];
var inputMask_default = inputMask;

// src/input-validation/utils.ts
var inputValidationType = (required) => required ? "required|matches" : "matches";
var requiredMessage = ({ node }) => `${node.context.label} is required.`;
var generateValidation = ({
  required,
  rules,
  example,
  type
}) => ({
  type: inputValidationType(required),
  rules,
  messages: {
    matches: `Please enter a valid ${type}. (Ex: ${example})`,
    required: requiredMessage
  }
});

// src/input-validation/inputPhoneValidation.ts
var US_PHONE_VALIDATION_STRATEGY = {
  rules: {
    required: (node) => Boolean(node.value) && !/\+1 ___-___-____/.test(node.value),
    matches: (node) => /\d{3}[-]\d{3}[-]\d{4}$|(\+1 ___-___-____)/.test(node.value)
  },
  example: "+1 123-456-7890"
};
var DEFAULT_PHONE_VALIDATION_STRATEGY = {
  rules: {
    matches: (node) => /^\d+$/.test(node.value)
  },
  example: "1234567890"
};
var inputPhoneStrategy = {
  Default: DEFAULT_PHONE_VALIDATION_STRATEGY,
  US: US_PHONE_VALIDATION_STRATEGY,
  CA: US_PHONE_VALIDATION_STRATEGY
};
var inputPhoneValidation = ({
  locale,
  required
}) => {
  const { rules, example } = inputPhoneStrategy[locale] || inputPhoneStrategy.Default;
  return generateValidation({ type: "phone", required, rules, example });
};
var inputPhoneValidation_default = inputPhoneValidation;

// src/input-validation/inputZipValidation.ts
var inputZipValidationStrategy = {
  Default: {
    rules: {
      matches: (node) => /./.test(node.value)
    },
    example: "12345"
  },
  US: {
    rules: {
      required: (node) => Boolean(node.value) && !/_{5}/.test(node.value),
      matches: (node) => {
        const isEmpty = /_{5}/.test(node.value);
        const isValid = /^\d{5}$/.test(node.value);
        return isEmpty || isValid;
      }
    },
    example: "12345"
  },
  CA: {
    rules: {
      required: (node) => Boolean(node.value) && !/^_{3}\s_{3}$/.test(node.value),
      matches: (node) => {
        const isEmpty = /^_{3}\s_{3}$/.test(node.value);
        const isValid = /^[A-Za-z]\d[A-Za-z]\s\d[A-Za-z]\d$/.test(node.value);
        return isEmpty || isValid;
      }
    },
    example: "V6Z 1B9"
  }
};
var inputZipValidation = ({
  locale,
  required
}) => {
  const { rules, example } = inputZipValidationStrategy[locale] || inputZipValidationStrategy.Default;
  return generateValidation({ type: "zip code", required, rules, example });
};
var inputZipValidation_default = inputZipValidation;

// src/input-validation/index.ts
var validationStrategy = {
  phone: inputPhoneValidation_default,
  zip: inputZipValidation_default
};
var inputValidation = ({ mask, locale = "US", required }) => validationStrategy[mask]({ locale, required });
var input_validation_default = inputValidation;

// src/is-array/index.ts
var isArray = (value) => {
  return value instanceof Array;
};
var is_array_default = isArray;

// src/is-valid-email/index.ts
var isValidEmail = (email) => /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(String(email));
var is_valid_email_default = isValidEmail;

// src/is-valid-url/index.ts
var isValidURL = (url) => /^(?:(?:https?):\/\/)?(?:[\w-]+\.)+[a-z]{2,}(?::\d+)?(?:\/[^/?#]+)*(\/)?(?:\?[^#]*)?(?:#.*)?$/.test(
  url
);
var is_valid_url_default = isValidURL;

// src/log-app-version/index.ts
var logAppVersion = ({
  name,
  version
}) => {
  console.log(
    `%c spectora ${name} %c version: ${version} %c `,
    "background:#203851 ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
    "background: #3F6C9E; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff",
    "background:transparent"
  );
};
var log_app_version_default = logAppVersion;

// src/to-form-data/index.ts
var toFormData = ({
  prefix = "",
  data,
  parseMultipartArrays = false
}) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key]) && parseMultipartArrays) {
      Object.values(data[key]).forEach((value) => {
        const name = prefix ? `${prefix}[${key}][]` : `${key}[]`;
        formData.append(name, String(value));
      });
    } else {
      const name = prefix ? `${prefix}[${key}]` : key;
      formData.append(name, data[key]);
    }
  });
  return formData;
};
var to_form_data_default = toFormData;

// src/underscore-to-camel/index.ts
var underscore_to_camel_default = format_camel_case_default;

// src/underscore-to-pascal/index.ts
var underscoreToPascal = (str) => {
  return str.split("/").map(
    (snake) => snake.split("_").map((substr) => substr.charAt(0).toUpperCase() + substr.slice(1)).join("").split("-").map((substr) => substr.charAt(0).toUpperCase() + substr.slice(1)).join("")
  ).join("/");
};
var underscore_to_pascal_default = underscoreToPascal;
export {
  arrays_contain_same_elements_default as arraysContainSameElements,
  dig_default as dig,
  format_bytes_default as formatBytes,
  format_camel_case_default as formatCamelCase,
  format_phone_default as formatPhone,
  formatText_default as formatText,
  generateUUid,
  inputMask_default as inputMask,
  input_validation_default as inputValidation,
  is_array_default as isArray,
  is_valid_email_default as isValidEmail,
  is_valid_url_default as isValidURL,
  log_app_version_default as logAppVersion,
  to_form_data_default as toFormData,
  underscore_to_camel_default as underscoreToCamel,
  underscore_to_pascal_default as underscoreToPascal
};
